import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { X, ArrowRight } from "lucide-react";

export default function CitePopover({ item, dark }) {
  const [open, setOpen] = useState(false);
  const timer = useRef(null);
  const show = () => { clearTimeout(timer.current); setOpen(true); };
  const hide = () => { timer.current = setTimeout(() => setOpen(false), 180); };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          onMouseEnter={show}
          onMouseLeave={hide}
          onClick={() => { clearTimeout(timer.current); setOpen((o) => !o); }}
          aria-label={`Source ${item.id}`}
          data-testid={`cite-trigger-${item.id}`}
          className={`cite-pulse relative inline-flex h-4 w-4 items-center justify-center rounded-full align-super ml-1.5 ${dark ? "bg-[#7DE3B4]" : "bg-[#2C6BAC]"}`}
        >
          <span className="h-1.5 w-1.5 rounded-full bg-white" />
        </button>
      </PopoverTrigger>
      <PopoverContent side="top" align="start" className="w-80 z-[300] p-4 text-[#1A1A2E]" onMouseEnter={show} onMouseLeave={hide} data-testid={`cite-content-${item.id}`}>
        <div className="flex items-start justify-between gap-2">
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#2C6BAC] font-semibold">Source {item.id}</p>
          <button type="button" onClick={() => setOpen(false)} aria-label="Close" data-testid={`cite-close-${item.id}`}
            className="h-7 w-7 -mt-1.5 -mr-1.5 rounded-full hover:bg-[#F8F9FC] flex items-center justify-center text-[#555568]">
            <X size={14} />
          </button>
        </div>
        <p className="mt-1 text-xs leading-relaxed">{item.context}</p>
        <p className="mt-2 text-[11px] italic text-[#555568] leading-relaxed">{item.ref}</p>
        <Link to={`/resources?cite=${item.id}#research`} className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-[#2C6BAC] hover:text-[#1A3A5C]" data-testid={`cite-read-more-${item.id}`}>
          Read more <ArrowRight size={12} />
        </Link>
      </PopoverContent>
    </Popover>
  );
}
